import React from "react";
import "./Logo.css";

import img1 from "../../images/logo.png";

function Logo() {
  return (
    <div>
      <img src={img1} alt="logo"></img>
    </div>
  );
}

export default Logo;
